import Phaser from 'phaser';

/** Event map: event name → argument tuple. */
export type EventMap = Record<string, unknown[]>;

/** Thin type-safe wrapper around Phaser's EventEmitter. */
export class TypedEmitter<E extends EventMap> {
  private readonly ee = new Phaser.Events.EventEmitter();

  on<K extends keyof E & string>(event: K, fn: (...args: E[K]) => void, context?: unknown): this {
    this.ee.on(event, fn, context);
    return this;
  }

  once<K extends keyof E & string>(event: K, fn: (...args: E[K]) => void, context?: unknown): this {
    this.ee.once(event, fn, context);
    return this;
  }

  off<K extends keyof E & string>(event: K, fn?: (...args: E[K]) => void, context?: unknown): this {
    this.ee.off(event, fn, context);
    return this;
  }

  emit<K extends keyof E & string>(event: K, ...args: E[K]): boolean {
    return this.ee.emit(event, ...args);
  }

  removeAllListeners(): this {
    this.ee.removeAllListeners();
    return this;
  }
}
